// Auto-generated from docs/菜单.md. i18n for breadcrumb.
export const messages = {
  zh: { breadcrumb: {
  "path_pages_scm_couponMarket": "优惠券市场",
  "path_pages_scm_couponPropertyPoolManage": "优惠券",
  "path_pages_scm_couponPropertyPoolDetail": "赠送记录",
  "path_pages_scm_couponPropertyUserManage": "业主优惠券",
  "path_pages_scm_couponPropertyUserDetail": "优惠券使用",
  "path_pages_scm_couponRule": "赠送规则",
  "path_pages_scm_integralConfigManage": "积分标准",
  "path_pages_scm_integralGiftDetailManage": "积分赠送",
  "path_pages_scm_communityIntegral": "小区积分",
  "path_pages_scm_integralRule": "积分规则",
  "path_pages_scm_gold": "小区金币",
  "path_pages_common_noticeManage": "发布公告",
  "path_pages_property_visitManage": "访客登记",
  "path_pages_complaint_complaint": "投诉建议",
  "path_pages_property_activitiesManage": "信息发布",
  "path_pages_property_activitiesTypeManage": "信息大类",
  "path_pages_property_questionAnswerManage": "问卷调研",
  "path_pages_question_questionTitle": "问卷题目",
  "path_pages_property_notepadManage": "业主反馈",
  "path_pages_question_ownerVoting": "业主投票",
  "path_pages_complaint_complaintType": "投诉类型",
  "path_pages_property_listParkingSpace": "车位信息",
  "path_pages_property_hireParkingSpace": "车位出租",
  "path_pages_property_sellParkingSpace": "车位出售",
  "path_pages_property_ownerParkingSpace": "业主车位",
  "path_pages_property_parkingAreaManage": "停车场管理",
  "path_pages_property_carInManage": "在场车辆",
  "path_pages_property_carInoutManage": "进场记录",
  "path_pages_property_remainingParkingSpace": "剩余车位",
  "path_pages_property_listOwnerCar": "业主车辆",
  "path_pages_property_carAddParkingSpace": "续租车位",
  "path_pages_property_listOwnerCarMember": "子母车辆",
  "path_pages_property_parkingBoxManage": "岗亭管理",
  "path_pages_property_parkingSpaceApplyManage": "车位申请",
  "path_pages_car_tempCarPayment": "临时车缴费",
  "path_pages_reserve_reserveCatalogManage": "预约目录",
  "path_pages_reserve_reserveParamsManage": "预约参数",
  "path_pages_reserve_reserveOrder": "预约订单",
  "path_pages_reserve_reserveDiningManage": "预约就餐",
  "path_pages_reserve_reserveConfirm": "订单核销",
  "path_pages_reserve_reserveServiceManage": "预约服务",
  "path_pages_property_equipmentAccount": "设备台账",
  "path_pages_property_machineTranslateManage": "物联网同步",
  "path_pages_machine_accessControlInout": "开门记录",
  "path_pages_property_locationManage": "设备位置",
  "path_pages_property_machineTypeTreeManage": "设备类型",
  "path_pages_property_maintainanceItem": "检查项",
  "path_pages_property_maintainanceStandardManage": "保养标准",
  "path_pages_property_maintainancePlanManage": "保养计划",
  "path_pages_property_maintainanceTaskDetails": "保养明细",
  "path_pages_property_maintainanceTaskManage": "保养任务",
  "path_pages_print_machinePrinterManage": "云打印机",
  "path_pages_print_printerRule": "云打印规则",
  "path_pages_property_attendanceClassesManage": "考勤班组",
  "path_pages_property_todayAttendanceManage": "今日考勤",
  "path_pages_property_monthAttendanceManage": "月考勤",
  "path_pages_property_attendanceLogManage": "考勤记录",
  "path_pages_property_oaWorkflowManage": "流程实例",
  "path_pages_property_newOaWorkflowManage": "我的流程",
  "path_pages_property_newOaWorkflowDoing": "工作办理",
  "path_pages_property_staffAttendanceManage": "员工考勤",
  "path_pages_attendance_attendanceClassesStaffManage": "考勤人员",
  "path_pages_oa_workType": "工作单类型",
  "path_pages_oa_startWork": "起工作单",
  "path_pages_oa_doWork": "办工作单",
  "path_pages_oa_copyWork": "抄送我的",
  "path_pages_oa_workPool": "工作单池",
  "path_pages_oa_workDeduction": "工作单扣款",
  "path_pages_common_purchaseApplyManage": "采购申请",
  "path_pages_common_resourceStoreManage": "物品信息",
  "path_pages_common_itemOutManage": "物品领用",
  "path_pages_property_storehouseManage": "仓库信息",
  "path_pages_common_allocationStorehouseManage": "调拨申请",
  "path_pages_common_myResourceStoreManage": "我的物品",
  "path_pages_common_purchaseApplyDetailManage": "出入库明细",
  "path_pages_property_resourceSupplierManage": "供应商",
  "path_pages_common_allocationUserStorehouseManage": "转赠记录",
  "path_pages_common_resourceStoreUseRecordManage": "使用记录",
  "path_pages_common_allocationStorehouseDetailed": "调拨明细",
  "path_pages_common_resourceStoreSpecificationManage": "物品规格",
  "path_pages_property_assetInventoryManage": "盘点管理",
  "path_pages_resource_resourceAuditFlow": "审批配置",
  "path_pages_property_room": "房屋管理",
  "path_pages_property_listOwner": "业主信息",
  "path_pages_property_ownerDetail": "业主详情",
  "path_pages_property_auditAuthOwner": "业主认证",
  "path_pages_property_shops": "商铺管理",
  "path_pages_property_accountManage": "业主账户",
  "path_pages_property_communitySpaceManage": "场地管理",
  "path_pages_property_communitySpacePersonManage": "场地预约订单",
  "path_pages_property_reportCommunitySpace": "场地预约",
  "path_pages_property_communitySpaceConfirm": "预约核销",
  "path_pages_owner_ownerSettledApplyManage": "业主入驻",
  "path_pages_owner_ownerCommitteeManage": "业委会",
  "path_pages_fee_invoiceApply": "发票",
  "path_pages_fee_ownerInvoice": "发票抬头",
  "path_pages_community_wechatSubscribe": "关注用户",
  "path_pages_property_repairDispatchStep": "报修派单",
  "path_pages_property_repairDispatchManage": "报修待办",
  "path_pages_property_myRepairDispatchManage": "报修已办",
  "path_pages_work_repairSetting": "报修设置",
  "path_pages_property_repairTypeUser": "报修师傅",
  "path_pages_property_ownerRepairManage": "电话报修",
  "path_pages_property_repairPoolManage": "工单池",
  "path_pages_property_ownerRepairDetail": "报修工单详情",
  "path_pages_property_repairReturnVisit": "报修回访",
  "path_pages_property_repairForceFinishManage": "强制回单",
  "path_pages_property_constrainFinishRepair": "强制回单",
  "path_pages_common_enterCommunity": "我的小区",
  "path_pages_property_simplifyAcceptance": "业务受理",
  "path_pages_property_roomRenovationManage": "房屋装修",
  "path_pages_property_roomRenovationDetailManage": "装修验收",
  "path_pages_property_listRoomDecorationRecord": "装修记录",
  "path_pages_property_listRoomRenovationRecordDetails": "装修详情",
  "path_pages_property_propertyRightRegistrationManage": "产权登记",
  "path_pages_property_videoControl": "视频监控",
  "path_pages_property_listPropertyRightRegistrationDetail": "产权登记详情",
  "path_pages_property_roomStructure": "结构图",
  "path_pages_property_carStructure": "车位结构图",
  "path_pages_property_itemReleaseTypeManage": "放行类型",
  "path_pages_property_itemReleaseManage": "物品放行",
  "path_pages_community_communityPublicityManage": "小区公示",
  "path_pages_property_reportFeeSummary": "费用汇总表",
  "path_pages_property_reportFeeDetail": "费用明细表",
  "path_pages_property_reportOweFeeDetail": "欠费明细表",
  "path_pages_report_feeRemind": "费用提醒",
  "path_pages_property_reportPayFeeDetail": "缴费明细表",
  "path_pages_property_reportRepair": "报修汇总表",
  "path_pages_property_reportProficient": "费用台账",
  "path_pages_property_reportNoFeeRoom": "未收费房屋",
  "path_pages_property_reportQuestionAnswerDetail": "问卷明细表",
  "path_pages_property_reportOwnerPayFee": "业主缴费明细",
  "path_pages_property_reportPayFeeDeposit": "押金报表",
  "path_pages_property_reportHuaning": "欠费分析",
  "path_pages_property_commonReport": "巡检报表",
  "path_pages_report_dataReport": "数据统计",
  "path_pages_property_staffFeeManage": "员工收费",
  "path_pages_property_feeConfigManage": "费用项设置",
  "path_pages_property_carCreateFee": "车辆收费",
  "path_pages_property_roomCreateFee": "房屋收费",
  "path_pages_property_feeSummary": "费用汇总表",
  "path_pages_property_returnPayFeeManage": "退费审核",
  "path_pages_fee_oweFeeCallable": "欠费催缴",
  "path_pages_property_roomFeeImport": "费用导入",
  "path_pages_property_listOweFee": "欠费信息",
  "path_pages_property_meterWaterManage": "水电抄表",
  "path_pages_fee_floorShare": "楼栋公摊",
  "path_pages_property_feeReceipt": "补打收据",
  "path_pages_property_payFeeAuditManage": "缴费审核",
  "path_pages_property_feeDiscountManage": "折扣设置",
  "path_pages_property_applyRoomDiscountManage": "优惠申请",
  "path_pages_property_contractCreateFee": "合同收费",
  "path_pages_property_payFeeBatch": "取消费用",
  "path_pages_property_feeComboManage": "费用套餐",
  "path_pages_fee_shareReading": "公摊抄表",
  "path_pages_admin_contractManage": "合同查询",
  "path_pages_admin_contractTypeManage": "合同类型",
  "path_pages_admin_contractTypeSpecManage": "合同类型规格",
  "path_pages_admin_contractAudit": "合同审核",
  "path_pages_admin_contractChangeManage": "合同变更",
  "path_pages_admin_expirationContractManage": "到期合同",
  "path_pages_admin_contractChangeDetails": "合同变更明细",
  "path_pages_admin_newContractManage": "起草合同",
  "path_pages_admin_contractChangeDetail": "申请合同变更",
  "path_pages_admin_contractApplyAuditHistoryOrders": "起草已办",
  "path_pages_admin_contractChangeAuditOrders": "变更待办",
  "path_pages_admin_contractApplyAuditOrders": "起草待办",
  "path_pages_admin_contractChangeAuditHistoryOrders": "变更已办",
  "path_pages_common_contractApplyDetail": "合同详情",
  "path_pages_admin_contractPartyaManage": "合同甲方",
  "path_pages_admin_addContract": "起草",
  "path_pages_inspection_inspectionPoint": "巡检点",
  "path_pages_inspection_inspectionRoute": "巡检路线",
  "path_pages_inspection_inspectionPlan": "巡检计划",
  "path_pages_inspection_inspectionTask": "巡检任务",
  "path_pages_property_inspectionTaskDetails": "巡检明细",
  "path_pages_property_inspectionItemManage": "巡检项目",
  "catalog_优惠": "优惠",
  "catalog_办公": "办公",
  "catalog_停车": "停车",
  "catalog_预约": "预约",
  "catalog_设备": "设备",
  "catalog_OA": "OA",
  "catalog_采购": "采购",
  "catalog_房产": "房产",
  "catalog_报修": "报修",
  "catalog_小区": "小区",
  "catalog_报表": "报表",
  "catalog_费用": "费用",
  "catalog_合同": "合同",
  "catalog_巡检": "巡检"
} },
  en: { breadcrumb: {
  "path_pages_scm_couponMarket": "优惠券市场",
  "path_pages_scm_couponPropertyPoolManage": "优惠券",
  "path_pages_scm_couponPropertyPoolDetail": "赠送记录",
  "path_pages_scm_couponPropertyUserManage": "业主优惠券",
  "path_pages_scm_couponPropertyUserDetail": "优惠券使用",
  "path_pages_scm_couponRule": "赠送规则",
  "path_pages_scm_integralConfigManage": "积分标准",
  "path_pages_scm_integralGiftDetailManage": "积分赠送",
  "path_pages_scm_communityIntegral": "小区积分",
  "path_pages_scm_integralRule": "积分规则",
  "path_pages_scm_gold": "小区金币",
  "path_pages_common_noticeManage": "发布公告",
  "path_pages_property_visitManage": "访客登记",
  "path_pages_complaint_complaint": "投诉建议",
  "path_pages_property_activitiesManage": "信息发布",
  "path_pages_property_activitiesTypeManage": "信息大类",
  "path_pages_property_questionAnswerManage": "问卷调研",
  "path_pages_question_questionTitle": "问卷题目",
  "path_pages_property_notepadManage": "业主反馈",
  "path_pages_question_ownerVoting": "业主投票",
  "path_pages_complaint_complaintType": "投诉类型",
  "path_pages_property_listParkingSpace": "车位信息",
  "path_pages_property_hireParkingSpace": "车位出租",
  "path_pages_property_sellParkingSpace": "车位出售",
  "path_pages_property_ownerParkingSpace": "业主车位",
  "path_pages_property_parkingAreaManage": "停车场管理",
  "path_pages_property_carInManage": "在场车辆",
  "path_pages_property_carInoutManage": "进场记录",
  "path_pages_property_remainingParkingSpace": "剩余车位",
  "path_pages_property_listOwnerCar": "业主车辆",
  "path_pages_property_carAddParkingSpace": "续租车位",
  "path_pages_property_listOwnerCarMember": "子母车辆",
  "path_pages_property_parkingBoxManage": "岗亭管理",
  "path_pages_property_parkingSpaceApplyManage": "车位申请",
  "path_pages_car_tempCarPayment": "临时车缴费",
  "path_pages_reserve_reserveCatalogManage": "预约目录",
  "path_pages_reserve_reserveParamsManage": "预约参数",
  "path_pages_reserve_reserveOrder": "预约订单",
  "path_pages_reserve_reserveDiningManage": "预约就餐",
  "path_pages_reserve_reserveConfirm": "订单核销",
  "path_pages_reserve_reserveServiceManage": "预约服务",
  "path_pages_property_equipmentAccount": "设备台账",
  "path_pages_property_machineTranslateManage": "物联网同步",
  "path_pages_machine_accessControlInout": "开门记录",
  "path_pages_property_locationManage": "设备位置",
  "path_pages_property_machineTypeTreeManage": "设备类型",
  "path_pages_property_maintainanceItem": "检查项",
  "path_pages_property_maintainanceStandardManage": "保养标准",
  "path_pages_property_maintainancePlanManage": "保养计划",
  "path_pages_property_maintainanceTaskDetails": "保养明细",
  "path_pages_property_maintainanceTaskManage": "保养任务",
  "path_pages_print_machinePrinterManage": "云打印机",
  "path_pages_print_printerRule": "云打印规则",
  "path_pages_property_attendanceClassesManage": "考勤班组",
  "path_pages_property_todayAttendanceManage": "今日考勤",
  "path_pages_property_monthAttendanceManage": "月考勤",
  "path_pages_property_attendanceLogManage": "考勤记录",
  "path_pages_property_oaWorkflowManage": "流程实例",
  "path_pages_property_newOaWorkflowManage": "我的流程",
  "path_pages_property_newOaWorkflowDoing": "工作办理",
  "path_pages_property_staffAttendanceManage": "员工考勤",
  "path_pages_attendance_attendanceClassesStaffManage": "考勤人员",
  "path_pages_oa_workType": "工作单类型",
  "path_pages_oa_startWork": "起工作单",
  "path_pages_oa_doWork": "办工作单",
  "path_pages_oa_copyWork": "抄送我的",
  "path_pages_oa_workPool": "工作单池",
  "path_pages_oa_workDeduction": "工作单扣款",
  "path_pages_common_purchaseApplyManage": "采购申请",
  "path_pages_common_resourceStoreManage": "物品信息",
  "path_pages_common_itemOutManage": "物品领用",
  "path_pages_property_storehouseManage": "仓库信息",
  "path_pages_common_allocationStorehouseManage": "调拨申请",
  "path_pages_common_myResourceStoreManage": "我的物品",
  "path_pages_common_purchaseApplyDetailManage": "出入库明细",
  "path_pages_property_resourceSupplierManage": "供应商",
  "path_pages_common_allocationUserStorehouseManage": "转赠记录",
  "path_pages_common_resourceStoreUseRecordManage": "使用记录",
  "path_pages_common_allocationStorehouseDetailed": "调拨明细",
  "path_pages_common_resourceStoreSpecificationManage": "物品规格",
  "path_pages_property_assetInventoryManage": "盘点管理",
  "path_pages_resource_resourceAuditFlow": "审批配置",
  "path_pages_property_room": "房屋管理",
  "path_pages_property_listOwner": "业主信息",
  "path_pages_property_ownerDetail": "业主详情",
  "path_pages_property_auditAuthOwner": "业主认证",
  "path_pages_property_shops": "商铺管理",
  "path_pages_property_accountManage": "业主账户",
  "path_pages_property_communitySpaceManage": "场地管理",
  "path_pages_property_communitySpacePersonManage": "场地预约订单",
  "path_pages_property_reportCommunitySpace": "场地预约",
  "path_pages_property_communitySpaceConfirm": "预约核销",
  "path_pages_owner_ownerSettledApplyManage": "业主入驻",
  "path_pages_owner_ownerCommitteeManage": "业委会",
  "path_pages_fee_invoiceApply": "发票",
  "path_pages_fee_ownerInvoice": "发票抬头",
  "path_pages_community_wechatSubscribe": "关注用户",
  "path_pages_property_repairDispatchStep": "报修派单",
  "path_pages_property_repairDispatchManage": "报修待办",
  "path_pages_property_myRepairDispatchManage": "报修已办",
  "path_pages_work_repairSetting": "报修设置",
  "path_pages_property_repairTypeUser": "报修师傅",
  "path_pages_property_ownerRepairManage": "电话报修",
  "path_pages_property_repairPoolManage": "工单池",
  "path_pages_property_ownerRepairDetail": "报修工单详情",
  "path_pages_property_repairReturnVisit": "报修回访",
  "path_pages_property_repairForceFinishManage": "强制回单",
  "path_pages_property_constrainFinishRepair": "强制回单",
  "path_pages_common_enterCommunity": "我的小区",
  "path_pages_property_simplifyAcceptance": "业务受理",
  "path_pages_property_roomRenovationManage": "房屋装修",
  "path_pages_property_roomRenovationDetailManage": "装修验收",
  "path_pages_property_listRoomDecorationRecord": "装修记录",
  "path_pages_property_listRoomRenovationRecordDetails": "装修详情",
  "path_pages_property_propertyRightRegistrationManage": "产权登记",
  "path_pages_property_videoControl": "视频监控",
  "path_pages_property_listPropertyRightRegistrationDetail": "产权登记详情",
  "path_pages_property_roomStructure": "结构图",
  "path_pages_property_carStructure": "车位结构图",
  "path_pages_property_itemReleaseTypeManage": "放行类型",
  "path_pages_property_itemReleaseManage": "物品放行",
  "path_pages_community_communityPublicityManage": "小区公示",
  "path_pages_property_reportFeeSummary": "费用汇总表",
  "path_pages_property_reportFeeDetail": "费用明细表",
  "path_pages_property_reportOweFeeDetail": "欠费明细表",
  "path_pages_report_feeRemind": "费用提醒",
  "path_pages_property_reportPayFeeDetail": "缴费明细表",
  "path_pages_property_reportRepair": "报修汇总表",
  "path_pages_property_reportProficient": "费用台账",
  "path_pages_property_reportNoFeeRoom": "未收费房屋",
  "path_pages_property_reportQuestionAnswerDetail": "问卷明细表",
  "path_pages_property_reportOwnerPayFee": "业主缴费明细",
  "path_pages_property_reportPayFeeDeposit": "押金报表",
  "path_pages_property_reportHuaning": "欠费分析",
  "path_pages_property_commonReport": "巡检报表",
  "path_pages_report_dataReport": "数据统计",
  "path_pages_property_staffFeeManage": "员工收费",
  "path_pages_property_feeConfigManage": "费用项设置",
  "path_pages_property_carCreateFee": "车辆收费",
  "path_pages_property_roomCreateFee": "房屋收费",
  "path_pages_property_feeSummary": "费用汇总表",
  "path_pages_property_returnPayFeeManage": "退费审核",
  "path_pages_fee_oweFeeCallable": "欠费催缴",
  "path_pages_property_roomFeeImport": "费用导入",
  "path_pages_property_listOweFee": "欠费信息",
  "path_pages_property_meterWaterManage": "水电抄表",
  "path_pages_fee_floorShare": "楼栋公摊",
  "path_pages_property_feeReceipt": "补打收据",
  "path_pages_property_payFeeAuditManage": "缴费审核",
  "path_pages_property_feeDiscountManage": "折扣设置",
  "path_pages_property_applyRoomDiscountManage": "优惠申请",
  "path_pages_property_contractCreateFee": "合同收费",
  "path_pages_property_payFeeBatch": "取消费用",
  "path_pages_property_feeComboManage": "费用套餐",
  "path_pages_fee_shareReading": "公摊抄表",
  "path_pages_admin_contractManage": "合同查询",
  "path_pages_admin_contractTypeManage": "合同类型",
  "path_pages_admin_contractTypeSpecManage": "合同类型规格",
  "path_pages_admin_contractAudit": "合同审核",
  "path_pages_admin_contractChangeManage": "合同变更",
  "path_pages_admin_expirationContractManage": "到期合同",
  "path_pages_admin_contractChangeDetails": "合同变更明细",
  "path_pages_admin_newContractManage": "起草合同",
  "path_pages_admin_contractChangeDetail": "申请合同变更",
  "path_pages_admin_contractApplyAuditHistoryOrders": "起草已办",
  "path_pages_admin_contractChangeAuditOrders": "变更待办",
  "path_pages_admin_contractApplyAuditOrders": "起草待办",
  "path_pages_admin_contractChangeAuditHistoryOrders": "变更已办",
  "path_pages_common_contractApplyDetail": "合同详情",
  "path_pages_admin_contractPartyaManage": "合同甲方",
  "path_pages_admin_addContract": "起草",
  "path_pages_inspection_inspectionPoint": "巡检点",
  "path_pages_inspection_inspectionRoute": "巡检路线",
  "path_pages_inspection_inspectionPlan": "巡检计划",
  "path_pages_inspection_inspectionTask": "巡检任务",
  "path_pages_property_inspectionTaskDetails": "巡检明细",
  "path_pages_property_inspectionItemManage": "巡检项目",
  "catalog_优惠": "优惠",
  "catalog_办公": "办公",
  "catalog_停车": "停车",
  "catalog_预约": "预约",
  "catalog_设备": "设备",
  "catalog_OA": "OA",
  "catalog_采购": "采购",
  "catalog_房产": "房产",
  "catalog_报修": "报修",
  "catalog_小区": "小区",
  "catalog_报表": "报表",
  "catalog_费用": "费用",
  "catalog_合同": "合同",
  "catalog_巡检": "巡检"
} }
}
